export enum ParameterTypeEnum {
	ThirtyDays = 1,
	VCDBChangeLogDB = 2,
	LightDutyPowersportsDB = 3,
	VCDBChangeLogDBBackup = 4,
	LightDutyPowersportsDBBackup = 5,
	TimeSupplierManuelAnswerQuote = 6,
	MinimalSuppliersAmountAutomaticOrderPart = 7,
	AllowOrderPartsOnlyWithFavoriteSuppliers = 8,
	MaximumDeliveryDeadlineAllowed = 9,
	MinimimDiscountAutomaticOrderPart = 10,
	MaximumOverpriceAllowedAutomaticOrderPart = 11,
	PercentageConsiderTotalLoss = 12,
	AlwaysEnsurePackagesSentByTheCarrier = 13,
	MinimumPartsToConsiderHighSeverity = 14,
	PercentageToPenalizeSupplierLowSeverity = 15,
	PercentageToPenalizeSupplierHighSeverity = 16,
	DaysToConsiderInSearchCart = 17,
	PercentageToPenalizeSupplierPrice = 18,
	MaximumImportLines = 19,
	DefaultSearchImportsInterval = 20,
	PCdb = 21,
	PCdbDBBackup = 22,
	ChangeStatusJobMinimumHours = 23,
	GuideNumberFixed = 24,
	MaximumSimpleImportLines = 25,
	RandomWanValue = 26,
	LogisticCost = 27,
	SupplierOrderMinimumValue = 28,
	PartCatalogJobWindow = 29,
	PartCatalogJobMinQuantity = 30,
	DaysToShowImportQuoteHistory = 31,
	MaxFilesToImportQuote = 32,
	ThirtyOneDays = 33,
	IntegrationQueueMaxAttempts = 34,
	AllowToCreateBodyshop = 35,
	BodyshopResponseTime = 37,
	CarrierCollectsPackage = 38,
	PriceCapByPartType = 39,
	PartQualityOrder = 40,
	DefaultReliabilityPercentage = 41,
	WeightPerType = 42,
	SearchClaimsInteval = 43,
	DeductiblePercentage = 44,
	ReceiveClaimsReport = 45,
	DefaultSearchPackageManageDaysInterval = 46,
	EnableHangfireInterface = 47,
	DefaultShippingCostReportInterval = 48,
	SupplierFeeXnuup = 49,
	DefaultSearchReporBillingDaysInterval = 50,
	DefaultSearchOrderDaysInterval = 51,
	DefaultSearchCartDaysInterval = 52,
	DefaultSearchOrderReportDaysInterval = 53,
	DefaultSearchClaimDaysInterval = 54,
	DaysToRequoteAnsweredParts = 55,
	DefaultSupplierPerformanceDaysInterval = 56,
	OrderScreenFilterClaimLength = 60,
	ClaimScreenFilterClaimLength = 61,
	DefaultRequoteReportDaysInterval = 71,
	RequoteTraceabilityScreenFilterClaimLength = 72,
	DefaultSearchOrderReportScheduleDaysInterval = 76,
	MaximumSearchOrderReportScheduleDaysInterval = 77,
	RecurrentSearchOrderReportScheduleDaysInterval = 78,
	ExpireStripeOxxo = 79,
	FlekkEmailAddress = 80,
	MinDeadlineAnswerRequote = 81,
	MaxDeadlineAnswerRequote = 82,
	TemporaryToken = 83,
	DynamicReportTimeout = 84,
	MinimumDiscountForTotalLossTransfer = 85,
	MaximumCompanyLogoSize = 113,
	MandatoryShippingInformation = 114,
	DefaultSearchRefundSummaryDaysInterval = 115,
	AutomaticRefundLimitUnblocking = 116,
	PercentageOfUnreceivedPartsAllowed = 117,
	QuoteCreationTimeThresholdToGenerateProcurement = 118,
	DefaultSearchAnnouncementDaysInterval = 119,
	MaximumSearchAnnouncementDaysInterval = 120,
	MaximumCreateAnnouncementDaysInterval = 121,
	MaximumCreateAnnouncementFile = 122,
	SingleStatusSearchOrderDaysInterval = 123,
	MaxSearchRangeDaysClaimSearchScreen = 124,
	SearchRangeDaysManagePartsCancelled = 130,
	PartsCancelledMaxSelect = 131,
	MaximumSupplierItemImageSize = 134,
	MaxEvidenceFileUploadMb = 146,
}
